// extracted by mini-css-extract-plugin
export var endSession = "ActiveSessionAlert-module--endSession--8a444";